import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  INVESTMENTS_PAGE_IMAGE_FOUR,
  INVESTMENTS_PAGE_IMAGE_ONE,
  INVESTMENTS_PAGE_IMAGE_THREE,
  INVESTMENTS_PAGE_IMAGE_TWO,
  INVESTMENTS_PAGE_IMAGE_FIVE,
  INVESTMENTS_PAGE_IMAGE_SIX,
  INVESTMENTS_PAGE_IMAGE_SEVEN,
  INVESTMENTS_PAGE_IMAGE_EIGHT,
  INVESTMENTS_PAGE_IMAGE_NINE,
  INVESTMENTS_PAGE_IMAGE_TEN,
  INVESTMENTS_PAGE_IMAGE_ELEVEN,
  INVESTMENTS_PAGE_IMAGE_TWELVE,
} from "../utils/constants"

const Investments = () => {
  const leftColumnData = [
    {
      title: "Healthcare Enterprises",
      desc: "Hospitals, clinics, and advanced medical infrastructure designed to enhance accessibility, deliver superior patient care, and support sustainable healthcare innovation across global markets.",
      imgPath: INVESTMENTS_PAGE_IMAGE_ONE,
    },
    {
      title: "Agricultural Enterprises",
      desc: "Modern farming techniques and sustainable food systems that improve productivity, strengthen food security, and promote long-term agricultural development for communities and industries.",
      imgPath: INVESTMENTS_PAGE_IMAGE_TWO,
    },
    {
      title: "Oil & Natural Gas Projects",
      desc: "Energy exploration, development, and trade initiatives powering industries, strengthening economies, and meeting global oil and natural gas demands with efficiency and reliability.",
      imgPath: INVESTMENTS_PAGE_IMAGE_THREE,
    },
    {
      title: "Educational Enterprises",
      desc: "Schools, universities, and e-learning platforms fostering innovation, empowering future generations, and ensuring accessible, technology-driven education for learners worldwide.",
      imgPath: INVESTMENTS_PAGE_IMAGE_FOUR,
    },
    {
      title: "Water Enterprises",
      desc: "Water treatment, desalination, and infrastructure projects that secure sustainable supply, support resource management, and enhance long-term resilience for communities and industries.",
      imgPath: INVESTMENTS_PAGE_IMAGE_FIVE,
    },
    {
      title: "Sports Enterprises",
      desc: "State-of-the-art sports facilities, clubs, and international investments encouraging athletic excellence, community engagement, and global participation in the evolving sports industry.",
      imgPath: INVESTMENTS_PAGE_IMAGE_SIX,
    },
  ]

  const rightColumnData = [
    {
      title: "Energy Enterprises",
      desc: "Renewable, solar, and conventional power projects delivering sustainable energy solutions that reduce environmental impact and ensure reliable power for future growth.",
      imgPath: INVESTMENTS_PAGE_IMAGE_SEVEN,
    },
    {
      title: "Commercial Enterprises",
      desc: "Retail, trading, and wholesale ventures creating dynamic platforms that connect global markets, drive commerce, and foster long-term business partnerships.",
      imgPath: INVESTMENTS_PAGE_IMAGE_EIGHT,
    },
    {
      title: "Tourism Enterprises",
      desc: "Hospitality, resorts, and travel-related ventures offering world-class experiences, promoting cultural exchange, and positioning destinations as leading global tourism hubs.",
      imgPath: INVESTMENTS_PAGE_IMAGE_NINE,
    },
    {
      title: "Industrial Enterprises",
      desc: "Manufacturing and large-scale industrial projects driving innovation, productivity, and sustainable development across diverse sectors in regional and international markets.",
      imgPath: INVESTMENTS_PAGE_IMAGE_TEN,
    },
    {
      title: "Retail Trade Enterprises",
      desc: "Shopping, e-commerce, and consumer markets delivering modern retail solutions that enhance customer experience, strengthen ecosystems, and drive consistent business growth.",
      imgPath: INVESTMENTS_PAGE_IMAGE_ELEVEN,
    },
    {
      title: "Technological Enterprises",
      desc: "Fintech, AI, and digital innovation solutions shaping industries, accelerating growth, and transforming the future of technology on a global scale.",
      imgPath: INVESTMENTS_PAGE_IMAGE_TWELVE,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default Investments
